const Urls = {
  UpdateUser: "/api/user/update",
  // API - ZIADOST
  ZIADOST: "/api/ziadost",
  // API - VYJADRENIE
  VYJADRENIE: "/api/vyjadrenie",
  // API - ULOHA
  ULOHA: "/api/uloha",
  // API - MAPA
  MAPA_URL: "/api/mapa/url",
  MAPA_URL_LAT_LNG: "/api/mapa/url/latlng",
  // API - Password
  ChangePassword: "/api/login/changepassword",
  ForgotPassword: "/api/login/forgotpassword",
  // API - TABLES
  AA_DEF_OB: "/api/aadefob",
  ZP_SPRAVY_UZ: "/api/spravy",
  // API - CISELNIKY
  ZP_C_DOVOD: "/api/dovody",
  ZP_C_PRIORITA: "/api/priority",
  ZP_C_TYP_PRACE: "/api/typyprace",
  ZP_C_STAV_ZIADOSTI: "/api/stavyziadosti",
  ZP_C_VYSLEDOK_VYJADRENIA: "/api/vysledokvyjadrenia",
  // API - FILES
  GET_USER_MANUAL: "/api/files/manual/user",
  GET_ADMIN_MANUAL: "/api/files/manual/admin",
  GET_PRILOHA: "/api/files/priloha",
  UPLOAD_PRILOHA_ZIADOST: "/api/files/priloha/ziadost/upload",
  UPLOAD_PRILOHA_VYJADRENIE: "/api/files/priloha/vyjadrenie/upload",
  // API_REPORTS
  REPORTS: "/api/reports",
  UPLOAD_REPORT: "/api/reports/upload",
  GET_REPORTS_NAMES: "/api/reports/names",
};

export default Urls;
